/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".location-option.mat-active[_ngcontent-%COMP%], .location-option.mat-option[_ngcontent-%COMP%]:hover{background:#039be5!important;color:#fff!important;font-size:20px!important}"];
export { styles as styles };
